import { getCaseId, getClientId } from "../../Utils/helper";
import api, { api_without_cancellation } from "../api";

const fetchCaseSummary = (clientId, caseId) => {
  return new Promise((resolve, reject) => {
    api_without_cancellation
      .get(`/api/cases/${clientId}/${caseId}/summary/`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const fetchHeaderSummary = (clientId, caseId) => {
  return new Promise((resolve, reject) => {
    api_without_cancellation
      .get(`/api/general/header_data/?case_id=${caseId}&client_id=${clientId}&page_name=Client`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

async function updateCaseDates(data) {
  const res = await new Promise((resolve, reject) => {
    api
      .put(`/api/cases/${getClientId()}/${getCaseId()}/summary/?tab=case_dates`, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
  return res;
}

async function updateCaseType(data) {
  const res = await new Promise((resolve, reject) => {
    api
      .put(`/api/cases/${getClientId()}/${getCaseId()}/summary/?tab=case_type`, data)
      .then((response) => {
        // document.getElementById("edit-case-dates-modal").click();

        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
  return res;
}

export { fetchCaseSummary, fetchHeaderSummary, updateCaseDates, updateCaseType };
